export const FORMS_LIST_PER_PAGE_OPTIONS = [15, 25, 50, 100] as const;
